var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclusive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2214 24C10.5472 17.3099 9.50876 11.0931 7.82746 5.71105C5.40328 5.20813 2.97887 5.20813 0.554688 5.71105L11.2214 24Z",
    fill: "#62B4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6159 5.71105C12.1266 5.46917 9.80501 5.40656 7.82812 5.71105L11.222 24C12.6928 18.0464 13.8126 11.9454 14.6159 5.71105Z",
    fill: "#7ACCE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2207 24L14.6146 5.71108C16.8572 5.19129 19.2932 5.22474 21.8874 5.71108L11.2207 24Z",
    fill: "#A3DDEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60968 0C6.11842 1.98794 7.30811 3.91441 7.82722 5.71108H0.554688L4.60968 0Z",
    fill: "#7ACCE8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.221 0C10.2831 2.28243 9.22591 4.33127 7.82715 5.71108L4.60938 0H11.221Z",
    fill: "#62B4D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6159 5.71108C13.8785 3.57304 12.6611 1.72062 11.222 0L7.82812 5.71108H14.6159Z",
    fill: "#A4DCEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6146 5.71108C16.1193 4.12113 17.0374 2.1369 17.7286 0H11.2207L14.6146 5.71108Z",
    fill: "#C3E7F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6152 5.7099H21.8875L17.7275 0.000244141L14.6152 5.7099Z",
    fill: "#EBF7FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusive);
export default __webpack_public_path__ + "static/media/exclusive.5c65d943.svg";
export { ForwardRef as ReactComponent };